import React, { useContext, useState } from "react";
import { API } from "../conf";
import { Context } from "../App";
import { Backdrop, Box, Button, CircularProgress, MenuItem, Stack, TextField, Typography, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { categories, list_repas } from "../conf";

export default function EditDeleguesForm({delegues, update, close}) {
    const { updateConnect } = useContext(Context);
    const [load, setLoad] = useState(false);
    const [categorie, setCategorie] = useState('');
    const [repas, setRepas] = useState(list_repas.map(repas => ({ repas, count: 0 })));
    const [transport, setTransport] = useState(false);
    const [msg, setMsg] = useState();

    async function handleSubmit(event) {
        event.preventDefault();
        setLoad(true);
        setMsg('');
        fetch(API.concat(`/delegues`), {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            },
            body: JSON.stringify({categorie, repas, transport, delegues: delegues.map(d=>d._id)})
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    update(json);
                    close();
                } else {
                    const text = await response.text();
                    setMsg(text);
                }
            }
        }).catch(err => setMsg(err.message)).finally(()=> setLoad(false));
    }

    return (
        <Box component='form' onSubmit={handleSubmit} display='flex' flex={1} flexDirection='column'>
            <Typography variant="h5" align="center" marginBottom='5px'>Modifier {delegues.length} délégué{delegues.length > 1 ? 's' : ''}</Typography>
            <Typography align="center" marginBottom='15px' color={'carmine.main'}>{msg}</Typography>
            
            <Stack direction='column' spacing={2} marginInline='20px'> 
                <TextField select required fullWidth value={categorie} onChange={e => setCategorie(e.target.value)} label="Catégorie">
                    {categories.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
                </TextField>

                <Typography variant="h6" align="center" marginBottom='5px'>Repas</Typography>
                <Stack direction='row' rowGap={2} columnGap={2} alignItems='center' flexWrap='wrap'>
                    {repas.map(repas =>
                    <TextField label={repas.repas} key={repas.repas} type="number" slotProps={{ input: { min: 0 } }}
                        sx={{ minWidth: '150px' }} value={repas.count} 
                        onChange={(event) => setRepas(old=>{
                            const copy = [...old];
                            copy.find(r=>r.repas===repas.repas).count = event.target.value;
                            return copy;
                        })} />
                    )}
                </Stack>

                <Typography variant="h6" align="center" marginBottom='5px'>Transport</Typography>
                <RadioGroup row sx={{minWidth:'280px', justifyContent:'center'}}
                defaultValue={transport}
                name="radio-buttons-group"
                onChange={(event)=> setTransport(event.target.value)}
                >
                    <FormControlLabel value={true} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Oui" slotProps={{typography:{fontSize:15}}} />
                    <FormControlLabel value={false} control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize:15}}}/>} label="Non" slotProps={{typography:{fontSize:15}}} />
                </RadioGroup>
            </Stack>

            <Button variant="contained" type="submit" sx={{ marginTop: '20px', borderRadius: 0, paddingBlock: 1.5 }}>Enregistrer</Button>
            <Backdrop open={load}><CircularProgress /></Backdrop>
        </Box>
    );
}